import Router from "@/helpers/router";
import {
  WHATS_NEW_AUDIENCES,
  WHATS_NEW_ICONS,
  WhatsNewEntryI,
} from "@/modules/whats-new/lib/types";

const { CALLER, POD_LEAD, LGA, ADMIN } = WHATS_NEW_AUDIENCES;

const CALLER_TITLE = "Your daily to-dos are in the app";
const MANAGER_TITLE = "Daily to-dos for your callers";

/**
 * Leads → To-Dos (C-16 S6, GLE-8406; coordinator decisions C16-D470–D482,
 * D459). It shows only while the backend's `daily_todos_enabled` is on (see
 * useDailyTodosWhatsNewCards), inside a wide window from the release, and
 * each viewer sees it on two ET days from the switch-on (the default day cap,
 * C16-D425).
 */
export const DAILY_TODOS_2026_10_27: WhatsNewEntryI = {
  id: "2026-10-27-daily-todos",
  startsAt: "2026-10-27T04:00:00.000Z",
  // Wide on purpose (C16-D425): the card waits for the switch-on, then each
  // viewer sees it on two ET days.
  endsAt: "2026-11-24T05:00:00.000Z",
  title: {
    [CALLER]: CALLER_TITLE,
    [POD_LEAD]: CALLER_TITLE,
    [LGA]: MANAGER_TITLE,
    [ADMIN]: MANAGER_TITLE,
  },
  intro: {
    [CALLER]: "Command Center's “To-Do's” now live under Leads → To-Dos.",
    [POD_LEAD]: "Command Center's “To-Do's” now live under Leads → To-Dos.",
    [LGA]: "Command Center's “To-Do's” moved into the app for every caller.",
    [ADMIN]: "Command Center's “To-Do's” moved into the app for every caller.",
  },
  sections: [
    {
      id: "todos",
      audiences: [CALLER, POD_LEAD],
      icon: WHATS_NEW_ICONS.CALENDAR,
      title: "Leads → To-Dos",
      items: [
        "Each day: today's and tomorrow's meetings to confirm, and the no-shows and cancels to rebook.",
        "Open a card to work it. Calls, emails and callbacks you log in the app tick it too.",
        "Pick your daily reminder time. You can snooze it once a day; then finish the list.",
      ],
      link: { label: "Open To-Dos", href: Router.todos() },
    },
    {
      id: "todos-managers",
      audiences: [LGA, ADMIN],
      icon: WHATS_NEW_ICONS.TEAM,
      title: "What your callers see",
      items: [
        "Leads → To-Dos: their meetings for today and tomorrow, and their no-shows and cancels to follow up.",
        "A reminder at the time they pick, a snooze once a day, then they finish the list before moving on.",
      ],
    },
  ],
};
